<mat-expansion-panel
  [expanded]="isExpanded()"
  [hideToggle]="surveyComponent.isLocked()"
  (closed)="resetPanelIndexIfNecessary()"
  (opened)="updatePanelIndex()">
  <mat-expansion-panel-header [class.locked]="surveyComponent.isLocked()">
    <mat-panel-title>
      <div class="left">
        <h4 class="position">{{ index() + 1 }}</h4>
        <h4>{{ question()?.title | translate }}</h4>
        @if (selectedAnswer() && !isExpanded()) {
          <div class="selected-answer">
            <mat-icon>check</mat-icon>
            <p>{{ selectedAnswer().title | translate }}</p>
          </div>
        }
      </div>
      @if (!surveyComponent.isLocked() && selectedAnswer() && isExpanded()) {
        <coin-v2-button
          text="{{ (isLastElement() ? 'survey.general.complete-survey' : 'survey.general.next-question') | translate }}"
          type="primary"
          icon="chevron_right"
          iconPos="right"
          (click)="openNextPanel($event)"></coin-v2-button>
      }
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <div class="answers">
      @for (answer of question()?.answers; track answer?.id || answer) {
        <coin-customer-survey-answer [answer]="answer"></coin-customer-survey-answer>
      }
    </div>
  </ng-template>
</mat-expansion-panel>
